import serverVars from 'server-vars';
import { sessionStorage } from 'dibs-browser-storage';

const DWELLED_ON_PDP_KEY = 'dwelledOnPdp' as const;
const DWELL_ON_PDP_LIMIT_DESKTOP = 22000;
const DWELL_ON_PDP_LIMIT_MOBILE = 19000;

export const getDwelledOnPdp = (): boolean => !!sessionStorage.getItem(DWELLED_ON_PDP_KEY);

export const setDwelledOnPdp = (): NodeJS.Timeout | undefined => {
    if (!getDwelledOnPdp()) {
        const isMobile = serverVars.get('settings.isMobile');
        const dwellTimeLimit = isMobile ? DWELL_ON_PDP_LIMIT_MOBILE : DWELL_ON_PDP_LIMIT_DESKTOP;

        return setTimeout(() => {
            sessionStorage.setItem(DWELLED_ON_PDP_KEY, true);
        }, dwellTimeLimit);
    }
    return undefined;
};
